const home = {
  hero: {
    badge: "Centre de ressources indépendant",
    title: "Tableau USFans : Trouvez, Comparez et Explorez les Ressources",
    subtitle: "Explorez le tableau USFans, les catégories de produits, les informations sur les vendeurs, les guides d'expédition, les avis, les coupons, les détails de l'entrepôt et les outils de recherche pratiques — le tout organisé dans un centre de ressources facile à utiliser.",
    searchPlaceholder: "Recherchez des produits, des vendeurs, l'expédition ou des guides...",
    trust: "Ressource indépendante · Guides actualisés · Multilingue · Axé sur la sécurité",
    primaryCta: "Explorer le tableau USFans",
    secondaryCta: "Visiter le site principal",
    supportTitle: "Vous cherchez un tableau USFans ?",
    supportText: "Trouvez des ressources organisées, des guides de recherche, des comparaisons et des informations pratiques pour vous aider à comprendre USFans avant de prendre une décision.",
    explore: [
      "Ressources du tableau",
      "Recherche de produits",
      "Informations sur les vendeurs",
      "Coûts d'expédition",
      "Guides d'entrepôt",
      "Avis",
      "Coupons et réductions",
      "Conseils de sécurité",
    ],
  },
  cta: {
    exploreSpreadsheet: "Explorer le tableau",
    usfansSpreadsheet: "Tableau USFans",
    buyItNow: "Acheter maintenant",
    visitMain: "Visiter le site principal",
    exploreAll: "Explorer toutes les ressources",
    continueMain: "Continuer vers le site principal",
  },
  categories: {
    title: "Parcourir les catégories de produits",
    subtitle: "Choisissez une catégorie ci-dessous pour découvrir les derniers produits disponibles sur le site principal.",
    dropdownLabel: "Sélectionnez une catégorie",
    dropdownPlaceholder: "Choisissez une catégorie de produits...",
    items: {
      shoes: "Chaussures",
      hoodies: "Hoodies / Pulls",
      tshirts: "T-shirts",
      jackets: "Vestes",
      pants: "Pantalons / Shorts",
      headwear: "Couvre-chefs",
      sets: "Ensembles",
      underwear: "Sous-vêtements",
      jersey: "Maillot",
      accessories: "Accessoires",
      bags: "Sacs",
      belts: "Ceintures",
      perfumes: "Parfums",
      other: "Autres articles",
    },
  },
  resources: {
    title: "Ressources populaires",
    subtitle: "Tout ce dont vous avez besoin pour étudier USFans, organisé en thèmes simples.",
    items: [
      { title: "Tableau USFans", desc: "Explorez les ressources, listes et guides de recherche du tableau." },
      { title: "Avis USFans", desc: "Comprenez les fonctionnalités, avantages, limites et considérations." },
      { title: "Coût d'expédition USFans", desc: "Apprenez ce qui influence les coûts d'expédition et comment comparer les options." },
      { title: "Entrepôt USFans", desc: "Comprenez le stockage, le traitement et les considérations associées." },
      { title: "Coupon et code promo", desc: "Trouvez les informations actuelles sur les coupons et réductions lorsqu'elles sont disponibles." },
      { title: "USFans est-il légitime ?", desc: "Lisez notre guide indépendant de sécurité et de légitimité." },
    ],
  },
  hub: {
    title: "Votre centre de ressources du tableau USFans",
    copy: "USFansSheet.live organise les ressources du tableau USFans en catégories consultables pour que vous passiez moins de temps à chercher et plus de temps à étudier.",
    cards: ["Listes du tableau", "Recherche de produits", "Recherche de vendeurs", "Expédition", "Entrepôt", "Avis", "Coupons", "Sécurité"],
  },
  why: {
    title: "Tout ce dont vous avez besoin pour étudier USFans au même endroit",
    items: [
      { title: "Organisé", desc: "Trouvez des informations liées au tableau USFans sans sauter entre des pages sans rapport." },
      { title: "Pratique", desc: "Les guides se concentrent sur de vraies questions que les gens recherchent réellement." },
      { title: "Actualisé", desc: "Les informations importantes affichent les dates de publication et de mise à jour." },
      { title: "Transparent", desc: "Distinguez clairement les faits vérifiés, l'analyse éditoriale et les informations qui peuvent changer." },
      { title: "Multilingue", desc: "Disponible en anglais, polonais, espagnol et français." },
    ],
  },
  comparison: {
    title: "Ressources USFans comparées",
    subtitle: "Un aperçu rapide de ce que chaque ressource vous aide à apprendre et pour qui elle est la meilleure.",
    headers: ["Sujet", "Ce que vous apprenez", "Idéal pour"],
    rows: [
      ["Tableau", "Listes, produits et recherche", "Recherche de produits"],
      ["Avis", "Fonctionnalités et limites", "Débutants"],
      ["Coût d'expédition", "Facteurs de coût et options", "Recherche d'expédition"],
      ["Entrepôt", "Stockage et traitement", "Utilisateurs actuels"],
      ["Coupon", "Promotions disponibles", "Économiser de l'argent"],
      ["Guide de légitimité", "Sécurité et vérification", "Conscience du risque"],
    ],
  },
  guides: {
    title: "Derniers guides",
    subtitle: "Lisez nos guides et articles originaux, rédigés de manière indépendante.",
    readGuide: "Lire le guide",
    readArticle: "Lire l'article",
    comingSoon: "Bientôt disponible",
    updatedLabel: "Mis à jour",
  },
  articleSection: {
    title: "Articles sur le tableau USFans",
    subtitle: "Des guides originaux et détaillés pour vous aider à étudier et comprendre USFans.",
    cardTitle: "Qu'est-ce que le tableau USFans ?",
    cardDesc: "Un guide complet et accessible aux débutants sur le fonctionnement du tableau USFans, comment le rechercher et comment rester en sécurité.",
    readMore: "Lire le guide complet",
  },
  safety: {
    title: "Renseignez-vous avant d'acheter",
    copy: "Les ressources en ligne peuvent changer. Les liens, vendeurs, prix, conditions d'expédition et promotions ne sont pas toujours à jour. Vérifiez toujours les informations importantes avant d'effectuer des paiements ou de partager des informations personnelles.",
    cta: "Lire le guide de sécurité USFans",
  },
  mainCta: {
    title: "Prêt à en découvrir plus ?",
    copy: "Utilisez nos guides et les ressources du tableau USFans comme point de départ, puis continuez vers le site principal pour les informations les plus récentes disponibles.",
  },
  faq: {
    title: "Questions fréquentes",
    items: [
      { q: "Qu'est-ce que le tableau USFans ?", a: "Le tableau USFans est une ressource organisée et consultable qui répertorie et compare les produits, catégories, vendeurs et informations de recherche associées. Il aide les acheteurs à trouver ce qu'ils cherchent plus rapidement." },
      { q: "Comment fonctionne le tableau USFans ?", a: "Il regroupe les produits et informations en catégories pour que vous puissiez parcourir, rechercher et comparer les options au même endroit au lieu de visiter de nombreuses pages séparées." },
      { q: "USFans est-il légitime ?", a: "Nous fournissons des conseils indépendants pour vous aider à vérifier les informations, mais nous ne pouvons pas garantir la légitimité d'un vendeur. Renseignez-vous toujours soigneusement et consultez les informations actuelles avant d'acheter." },
      { q: "Combien coûte l'expédition USFans ?", a: "Les coûts d'expédition peuvent changer selon l'emplacement, la méthode et le vendeur. Nous expliquons les facteurs qui influencent l'expédition afin que vous puissiez comparer les options vous-même." },
      { q: "USFans propose-t-il des coupons ?", a: "Des promotions et coupons peuvent être disponibles à certains moments. Nous décrivons comment chercher des offres actuelles, mais nous ne publions pas de codes de réduction garantis ni non vérifiés." },
      { q: "Où trouver des codes promo USFans ?", a: "Cherchez toujours les codes sur le site principal officiel ou les canaux vérifiés. Méfiez-vous des codes non officiels qui peuvent être obsolètes ou trompeurs." },
      { q: "Qu'est-ce que l'entrepôt USFans ?", a: "L'entrepôt concerne la façon dont les produits sont stockés et traités avant l'expédition. Nous expliquons le concept général et les éléments à considérer." },
      { q: "Le tableau USFans est-il officiel ?", a: "USFansSheet.live est une ressource informative indépendante et n'est pas nécessairement affilié à ni approuvé par USFans." },
      { q: "Comment vérifier les informations ?", a: "Recoupez les détails sur le site principal, consultez les mises à jour récentes et confirmez les prix, l'expédition et la disponibilité avant d'effectuer des paiements ou de partager des données personnelles." },
      { q: "À quelle fréquence les ressources sont-elles mises à jour ?", a: "Nous essayons de garder les informations à jour, mais les détails peuvent changer rapidement. Consultez toujours le site principal pour les informations les plus récentes." },
    ],
  },
};

export default home;